<template>
  <DashboardChartWrapper
    title="Tendance des ventes"
    :loading="loading"
    :error="error"
    @retry="refresh"
  >
    <template #controls>
      <GroupBySelect v-model="groupBy" />
    </template>
    <Line v-if="chartData" :data="chartData" :options="chartOptions" />
  </DashboardChartWrapper>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Line } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import { formatCurrency } from './helpers'
import DashboardChartWrapper from './DashboardChartWrapper.vue'
import GroupBySelect from './GroupBySelect.vue'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

const { dateParams } = useDateRange()
const groupBy = ref('day')

const params = computed(() => ({
  ...dateParams.value,
  group_by: groupBy.value
}))

const { data, loading, error, refresh } = useDashboard('/dashboard/charts/sales-trend', params)

const chartData = computed(() => {
  if (!data.value || !Array.isArray(data.value)) return null
  return {
    labels: data.value.map(d => d.label),
    datasets: [
      {
        label: 'CA TTC',
        data: data.value.map(d => d.revenue_ttc),
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59,130,246,0.1)',
        fill: true,
        tension: 0.3,
        yAxisID: 'y'
      },
      {
        label: 'Nb ventes',
        data: data.value.map(d => d.count),
        borderColor: '#10b981',
        backgroundColor: 'rgba(16,185,129,0.1)',
        fill: false,
        tension: 0.3,
        yAxisID: 'y1'
      }
    ]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: 'index', intersect: false },
  plugins: {
    legend: { position: 'top', labels: { usePointStyle: true, pointStyle: 'circle' } },
    tooltip: {
      callbacks: {
        label: (ctx) => {
          if (ctx.datasetIndex === 0) return `CA TTC: ${formatCurrency(ctx.raw)}`
          return `Nb ventes: ${ctx.raw}`
        }
      }
    }
  },
  scales: {
    y: { type: 'linear', position: 'left', ticks: { callback: v => formatCurrency(v) } },
    y1: { type: 'linear', position: 'right', grid: { drawOnChartArea: false } }
  }
}
</script>
